import React, { useState } from "react";
import { Button, Form, Input, message, Modal } from "antd";
import ButtonRow from "components/common/ButtonRow";
import RopeFileUpload from "./RopeFileUpload";
import { uploadRope } from "../../api/ropeApi";
import displayErrorNotification from "../../utils/displayErrorNotification";

type RopeUploadModalProps = {
  modalState: boolean;
  refresh: () => void;
  closeModal: () => void;
  setLoading: (enable: boolean) => void;
  onUploadSuccess?: (response: any) => void;
};

const RopeUploadModal = (props: RopeUploadModalProps) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [comment, setComment] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = (file: File | null) => {
    setSelectedFile(file);
  };

  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value);
  };

  const handleSave = async () => {
    if (!selectedFile) {
      message.error("Please select a file to upload");
      return;
    }
    props.setLoading(true);
    setUploading(true);

    try {
      const response = await uploadRope(selectedFile, comment);
      message.success("File uploaded successfully!");

      if (props.onUploadSuccess) {
        props.onUploadSuccess(response);
      }

      // Reset form and close modal
      setSelectedFile(null);
      setComment("");
      props.closeModal();
      props.refresh();
    } catch (error) {
      console.error("Upload error:", error);
      displayErrorNotification(error);
    } finally {
      setUploading(false);
      props.setLoading(false);
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setComment("");
    props.closeModal();
  };

  return (
      <Modal
          title={
            <>
              Upload ROPE File for a new or existing project{" "}
              <span style={{ color: "#e45f4c", fontWeight: 700 }}>to Scout</span>
            </>
          }
          visible={props.modalState}
          onCancel={handleCancel}
          footer={null}
      >
      <Form.Item label="Upload ROPE File">
        <RopeFileUpload
          maxSize={1024 * 1024 * 10} // 10 MB
          onFileSelect={handleFileSelect}
          disabled={uploading}
        />
      </Form.Item>

      <Form.Item label="Comment">
        <Input.TextArea
          value={comment}
          onChange={handleCommentChange}
          disabled={uploading}
          rows={4}
          placeholder="Enter any comments about this upload..."
        />
      </Form.Item>

      <ButtonRow style={{ marginTop: "1em" }}>
        <Button
          type="primary"
          onClick={handleSave}
          loading={uploading}
          disabled={!selectedFile}
        >
          Save
        </Button>
        <Button onClick={handleCancel} disabled={uploading}>
          Cancel
        </Button>
      </ButtonRow>
    </Modal>
  );
};

export default RopeUploadModal;
